/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const FileOrFolderType = {
    Dir: 'DIR',
    File: 'FILE',
    Container: 'CONTAINER'
};
export function instanceOfFileOrFolderType(value) {
    for (const key in FileOrFolderType) {
        if (Object.prototype.hasOwnProperty.call(FileOrFolderType, key)) {
            if (FileOrFolderType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FileOrFolderTypeFromJSON(json) {
    return FileOrFolderTypeFromJSONTyped(json, false);
}
export function FileOrFolderTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FileOrFolderTypeToJSON(value) {
    return value;
}
export function FileOrFolderTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
